// String helpers inspired by underscore.string
// https://github.com/esamattis/underscore.string

/**
 * Convert input to string
 * @param object
 * @returns {string}
 */
export const makeString = (object) => {
    return object === null ? '' : '' + object
}

/**
 * Escape string regex
 * @param str
 * @returns {string}
 */
export const escapeRegExp = (str) => {
    return makeString(str).replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1')
}

/**
 * standardize white space
 * @param characters
 * @returns {string|*}
 */
export const defaultToWhiteSpace = (characters) => {
    if (characters === null) {
        return '\\s'
    }

    if (characters.source) {
        return characters.source
    }

    return '[' + escapeRegExp(characters) + ']'
}

/**
 * Custom trim method
 * @param str
 * @param characters
 * @returns {string}
 */
export const trim = (str, characters) => {
    const nativeTrim = String.prototype.trim
    str = makeString(str)
    if (!characters && nativeTrim) {
        return nativeTrim.call(str)
    }
    characters = defaultToWhiteSpace(characters)
    return str.replace(new RegExp(`^${characters}+|${characters}+$`, 'g'), '')
}

/**
 * Remove accents / diacritics
 * @param str
 * @returns {string}
 */
export const cleanDiacritics = (str) => {
    let from = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž'.toUpperCase()
    let to = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz'.toUpperCase()

    to = to.split('')

    // for tokens requiring multitoken output
    from += 'ß'
    to.push('ss')

    return makeString(str).replace(/.{1}/g, function (c) {
        const index = from.indexOf(c)
        return index === -1 ? c : to[index]
    })
}

/**
 * export methods
 */
export default {
    cleanDiacritics,
    defaultToWhiteSpace,
    escapeRegExp,
    makeString,
    trim
}
